import type { GeoDesignElement } from '@entities/geodesy';

export const ACCEPT_TABLE = '.csv,.txt,.xlsx,.xls';
export const PAGE = 200;

export function rowValid(el: GeoDesignElement): boolean {
  return el.label.trim() !== '' && Number.isFinite(el.x) && Number.isFinite(el.y);
}
